export const agnieszkaGorna = {
    'meta': {
        'title': 'Psychoterapeutka, coach, mediator Agnieszka Górna • Centrum COLLIGO',
        'description': 'Jestem psychoterapeutką pracującą w nurcie psychodynamicznym w trakcie szkolenia, dyplomowanym coachem oraz mediatorką sądową.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-agnieszka-gorna/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/agnieszka-gorna.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeutka, coach, mediator Agnieszka Górna • Centrum COLLIGO'
        }
    }
}